import React, { useState } from "react"
import CustomImage from "@/main/customImage"
import { useSpring, animated } from "react-spring"
import { Waypoint } from "react-waypoint"

import { Card } from "react-bootstrap"

function ServiceCard(props) {
    const [inView, setInView] = useState(false)

    const fadeUp = useSpring({
        delay: 500,
        to: {
            opacity: inView ? 1 : 0,
            marginTop: inView ? 0 : 50,
        },
    })

    return (
        <Waypoint onEnter={() => setInView(true)}>
            <animated.div className="h-100" style={fadeUp}>
                <Card className=" px-2 py-4 h-100 " style={{ height: "100%" }}>
                    <div className="icon-div">
                        <CustomImage
                            src={`https://webb-jenkins-static-164679926.imgix.net/icons/${props.icon}`}
                            alt={props.alt}
                            layout="fill"
                            objectPosition="center"
                        />
                    </div>
                    <Card.Title className="text-center mt-3">
                        <span className="h5">{props.title}</span>
                    </Card.Title>
                </Card>
            </animated.div>
        </Waypoint>
    )
}

export default ServiceCard
